import './Error.css';

export default function Error() {
    return (
        <div className="mainDiv">
            <h1>FORE!</h1>
            <h2>Page Not Found</h2>
        </div>
    )
}